import React from "react"
import { useEffect, useState } from 'react'
import { withRouter } from "react-router-dom"
import { withTranslation } from "react-i18next"
import PropTypes from "prop-types"
import MetaTags from "react-meta-tags"
import { MDBDataTable } from "mdbreact"
import {
    Row, Col, CardBody, Card, Container, Modal, Button, Input
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"

const Feedback = props => {

    const [modal_center, setmodal_center] = useState(false)

    function view_orderDetail() {

        setmodal_center(!modal_center)
        removeBodyCss()
    }

    function removeBodyCss() {
        document.body.classList.add("no_padding")
    }


    const data = {
        columns: [
            {
                label: "Customer Name",
                field: "CustomerName",
                sort: "asc",
                attributes: { width: "15%" },
            },
            {
                label: "Mobile Number",
                field: "MobileNumber",
                sort: "asc",
                attributes: { width: "14%" },
            },
            {
                label: "Order No",
                field: "OrderNo",
                sort: "asc",
                attributes: { width: "13%" },
            },
            {
                label: "Customer Feedback",
                field: "CustomerFeedback",
                sort: "asc",
                attributes: { width: "25%" },
            },

            {
                label: "Vendor FeedBack",
                field: "VendorFeedBack",
                sort: "asc",
                attributes: { width: "25%" },
            },

            {
                label: "Reply",
                field: "Reply",
                sort: "asc",
                attributes: { width: "6" },
            },

        ],
        rows: [
            {
                CustomerName: "Yana Suthar",
                MobileNumber: "9638869115",
                OrderNo: "#6765767",
                CustomerFeedback: "Purus, in hendrerit nisl molestie lectus turpis lorem donec. Lorem consectetur quis tincidunt.",
                VendorFeedBack: "Purus, in hendrerit nisl molestie lectus turpis lorem donec. Lorem consectetur quis tincidunt.",
                Reply: (
                    <>
                        <div className="my-4 text-center">
                            <Button
                                className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
                                style={{ width: "25px", height: "25px", padding: "0px" }}
                                title="View"
                                onClick={() => {
                                    setmodal_center(true)
                                }}
                            >
                                <i className="fas fa-edit"></i>
                            </Button>
                        </div>
                        <Modal
                            size='md'
                            isOpen={modal_center}
                            toggle={() => {
                                view_orderDetail()
                            }}
                            centered={true}
                        >
                            <div className="modal-header">
                                <h5 className="modal-title mt-0">Customer FeedBack</h5>
                                <Button
                                    type="button"
                                    onClick={() => {
                                        setmodal_center(false)
                                    }}
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </Button>
                            </div>
                            <div className="modal-body">
                                <Row>
                                    <Col md={12}>
                                        <p>Purus, in hendrerit nisl molestie lectus turpis lorem donec. Lorem consectetur quis tincidunt.</p>

                                        <Col md={12}>
                                            <Row className="mb-3">
                                                <div className="col-lg-12">
                                                    <Input
                                                        id="BusinessAddress"
                                                        name="BusinessAddress"
                                                        type="textarea"
                                                        className="form-control mb-4"
                                                        placeholder="Write Response to Customer here"
                                                    />

                                                    <Button
                                                        color="primary"
                                                        outline
                                                        className="waves-effect waves-light"
                                                    >
                                                        Cancel
                                                    </Button>{" "}
                                                    <Button
                                                        color="primary"
                                                        className="btn btn-primary waves-effect waves-light"
                                                    >
                                                        Confirm
                                                    </Button>{" "}
                                                </div>
                                            </Row>
                                        </Col>
                                    </Col>
                                </Row>
                            </div>
                        </Modal>
                    </>
                ),
            },
        ],
    }
    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>{props.t("Feedback")} | Virtual Supermarket</title>
                </MetaTags>
                <Container fluid={true}>
                    <Breadcrumbs
                        title={props.t("Home")}
                        breadcrumbItem={props.t("Feedback")}
                    />
                    <Row>
                        <Col className="col-12">
                            <Card>
                                <CardBody>
                                    <MDBDataTable
                                        responsive
                                        bordered
                                        noBottomColumns
                                        theadColor={"btn-primary"}
                                        data={data}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}
Feedback.propTypes = {
    t: PropTypes.any,
}
export default withRouter(withTranslation()(Feedback))
